import React, {FC, useEffect, useState} from 'react'
import {ArrowBack} from '@mui/icons-material'
import {Box, Button, CircularProgress, IconButton} from '@mui/material'
import ControlTooltip from '@components/UI/Tooltip/ControlTooltip'
import {ActionWrapper, ButtonWrapper, HeaderWrapper, Title} from './Header.styles'
import {HeaderProps} from './HeaderProps'
import {HEADER_CONSTS} from './Header.consts'

const Header: FC<HeaderProps> = ({
  title,
  isValidForm,
  buttonDisabledTooltipMessage,
  loading,
  onBack,
  hasPreview = true
}) => {
  const [disableBtn, setDisableBtn] = useState(!isValidForm)
  const [disabledTitle, setDisabledTitle] = useState('')
  const [loadingBtn, setLoadingBtn] = useState(loading || false)

  useEffect(() => {
    setDisableBtn(!isValidForm)
  }, [isValidForm])

  useEffect(() => {
    setDisabledTitle(buttonDisabledTooltipMessage)
  }, [buttonDisabledTooltipMessage])

  useEffect(() => {
    setLoadingBtn(loading)
  }, [loading])

  return (
    <HeaderWrapper>
      <Box>
        <IconButton size='small' onClick={onBack}>
          <ArrowBack />
        </IconButton>
      </Box>
      <Title color='secondary'>{title}</Title>
      <ActionWrapper>
        {hasPreview && (
          <Button variant='outlined' color='primary'>
            {HEADER_CONSTS.preview}
          </Button>
        )}
        <ControlTooltip
          title=''
          disabledTitle={disabledTitle}
          enterDelay={500}
          disabled={disableBtn}
          color={'default'}
          withoutTooltipIfActive={true}
        >
          <ButtonWrapper type='submit' variant='contained' color='primary' disabled={disableBtn || loading}>
            {loadingBtn ? (
              <>
                <span>{HEADER_CONSTS.savingMsg}</span>
                <CircularProgress size='1rem' />
              </>
            ) : (
              <span>{HEADER_CONSTS.save}</span>
            )}
          </ButtonWrapper>
        </ControlTooltip>
      </ActionWrapper>
    </HeaderWrapper>
  )
}

export default Header
